import React, { useRef, useEffect, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { LocalShipping } from '@material-ui/icons';

import { ADM, GFE } from '~/constants/perfil';

import { UnidataTable } from '~/components';

import { recordFiltering } from '~/store/modules/operacaopostomanutencao/actions';

import EditarPosto from './components/EditarPosto';

function OperacaoPostoManutencaoList() {
  const dispatch = useDispatch();

  const [habEditarPosto, setHabEditarPosto] = useState(false);

  const { profile } = useSelector((state) => state.user);

  const operacaopostomanutencao = useSelector(
    (state) => state.operacaopostomanutencao
  );

  const editarPostoRef = useRef(null);

  const buttons = [];

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      switch (profile.glousuariotipo) {
        case ADM:
        case GFE:
          setHabEditarPosto(true);
          break;
        default:
          setHabEditarPosto(false);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  const handleUpdate = React.useCallback(() => {
    dispatch(recordFiltering(operacaopostomanutencao.params));
  }, [operacaopostomanutencao.params]);

  const header = useMemo(
    () => [
      {
        id: 'poco_descricao',
        label: 'Posto',
        filter: {
          type: 'text',
        },
      },
      {
        id: 'posto_modo_operacao',
        label: 'Modo Operação',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'poco_abastec_modo_site_str',
        label: 'Modo Abastecimento',
        filter: {
          type: 'text',
        },
        align: 'left',
      },
    ],
    []
  );

  const headerhabEditarPosto = useMemo(
    () => [
      habEditarPosto &&
        buttons.push({
          title: 'Editar Posto',
          action: (value) => editarPostoRef.current.handleToggleModal(value),
          icon: <LocalShipping />,
        }),
    ],
    [operacaopostomanutencao, habEditarPosto]
  );

  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="poco_desc_abrev ASC"
        title={'Posto Manutenção'}
        create={false}
        delete={false}
        update={false}
        fixed
        header={header}
        redux={operacaopostomanutencao}
        read={recordFiltering}
        actions={habEditarPosto ? buttons : undefined}
        detach="poco_descricao"
        keys="poco_codigo"
        view="VW_POSTO"
        reportTitle="Posto Manutenção"
      />
      <EditarPosto
        ref={editarPostoRef}
        update={() => handleUpdate()}
        name="EditarPosto"
      />
    </>
  );
}

export default OperacaoPostoManutencaoList;
